const countries = {
  en: {
    default: "Country",
    entries: [
      "Country",
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bhutan",
      "Bolivia",
      "Bosnia and Herzegovina",
      "Botswana",
      "Brazil",
      "Brunei ",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Côte d'Ivoire",
      "Cabo Verde",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Central African Republic",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Comoros",
      "Congo (Congo-Brazzaville)",
      "Costa Rica",
      "Croatia",
      "Cuba",
      "Cyprus",
      "Czechia",
      "Democratic Republic of the Congo",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Ethiopia",
      "Fiji",
      "Finland",
      "France",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Greece",
      "Grenada",
      "Guatemala",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Holy See",
      "Honduras",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Kuwait",
      "Kyrgyzstan",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Micronesia",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Morocco",
      "Mozambique",
      "Myanmar (formerly Burma)",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "North Korea",
      "North Macedonia",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Palestine State",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Qatar",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Korea",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan",
      "Suriname",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States of America",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela",
      "Vietnam",
      "Yemen",
      "Zambia",
      "Zimbabwe"
    ]
  },
  it: {
    default: "Stato",
    entries: [
      "Stato",
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Antigua e Barbuda",
      "Arabia Saudita",
      "Argentina",
      "Armenia",
      "Australia",
      "Austria",
      "Azerbaigian",
      "Bahamas",
      "Bahrein",
      "Bangladesh",
      "Barbados",
      "Belgio",
      "Belize",
      "Benin",
      "Bhutan",
      "Bielorussia",
      "Birmania",
      "Bolivia",
      "Bosnia ed Erzegovina",
      "Botswana",
      "Brasile",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambogia",
      "Camerun",
      "Canada",
      "Capo Verde",
      "Ciad",
      "Cile",
      "Cina",
      "Cipro",
      "Colombia",
      "Comore",
      "Congo",
      "Corea del Nord",
      "Corea del Sud",
      "Costa d'Avorio",
      "Costa Rica",
      "Croazia",
      "Cuba",
      "Danimarca",
      "Dominica",
      "Ecuador",
      "Egitto",
      "El Salvador",
      "Emirati Arabi Uniti",
      "Eritrea",
      "Estonia",
      "Etiopia",
      "Figi",
      "Filippine",
      "Finlandia",
      "Francia",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germania",
      "Ghana",
      "Giamaica",
      "Giappone",
      "Gibuti",
      "Giordania",
      "Grecia",
      "Grenada",
      "Guatemala",
      "Guinea",
      "Guinea Equatoriale",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Irlanda",
      "Islanda",
      "Isole Marshall",
      "Isole Salomone",
      "Israele",
      "Italia",
      "Kazakistan",
      "Kenya",
      "Kirghizistan",
      "Kiribati",
      "Kosovo",
      "Kuwait",
      "Laos",
      "Lesotho",
      "Lettonia",
      "Libano",
      "Liberia",
      "Libia",
      "Liechtenstein",
      "Lituania",
      "Lussemburgo",
      "Macedonia",
      "Madagascar",
      "Malawi",
      "Maldive",
      "Malesia",
      "Mali",
      "Malta",
      "Marocco",
      "Mauritania",
      "Mauritius",
      "Messico",
      "Micronesia",
      "Moldavia",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Mozambico",
      "Namibia",
      "Nauru",
      "Nepal",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Norvegia",
      "Nuova Zelanda",
      "Oman",
      "Paesi Bassi",
      "Pakistan",
      "Palau",
      "Palestina",
      "Panamá",
      "Papua Nuova Guinea",
      "Paraguay",
      "Perù",
      "Polonia",
      "Portogallo",
      "Qatar",
      "Regno Unito",
      "Repubblica Ceca",
      "Repubblica Centrafricana",
      "Repubblica Democratica del Congo",
      "Repubblica Dominicana",
      "Romania",
      "Ruanda",
      "Russia",
      "Saint Kitts e Nevis",
      "Saint Vincent e Grenadine",
      "Samoa",
      "San Marino",
      "Santa Lucia",
      "São Tomé e Príncipe",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Siria",
      "Slovacchia",
      "Slovenia",
      "Somalia",
      "Spagna",
      "Sri Lanka",
      "Stati Uniti",
      "Sudafrica",
      "Sudan",
      "Sudan del Sud",
      "Suriname",
      "Svezia",
      "Svizzera",
      "Swaziland",
      "Tagikistan",
      "Taiwan",
      "Tanzania",
      "Thailandia",
      "Timor Est",
      "Togo",
      "Tonga",
      "Trinidad e Tobago",
      "Tunisia",
      "Turchia",
      "Turkmenistan",
      "Tuvalu",
      "Ucraina",
      "Uganda",
      "Ungheria",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Vaticano",
      "Venezuela",
      "Vietnam",
      "Yemen",
      "Zambia",
      "Zimbabwe"
    ]
  }
};

export default countries;
